/**
 * 问题的转换比较多，单独抽成一个文件
 */
import { uniqueId } from "../common/util.js";
import { defaultPropId, effectChannel, answerStatus } from "../common/constants.js";
import widgetManager from "@/views/zhiji/js/modules/questionEdit/widgets/widgetManager.js";

// 问题信息
function cvtQuesInfo(result) {
    const stdQuestion0 = result.std_questions[0];

    return {
        questionId: stdQuestion0.question_id,
        sceneClassId: stdQuestion0.set_id,
        standQuestion: stdQuestion0.question,
        optionTip: stdQuestion0.fast_name,
        lang: stdQuestion0.lang,
        enQuestionId: stdQuestion0.en_question_id,
        isLikeDisplay: stdQuestion0.is_like_display,
        lockingStatus: stdQuestion0.lock_status
    };
}

// 问题答案列表
function cvtAnswerList(result) {
    const answers = result.std_answers || [];
    return answers.map(function(answer) {
        return {
            name: answer.answer_alias,
            id: answer.answer_id,
            props: cvtAnswerProp(answer.answer_attribute, answer.tag, answer.dm_status),
            contents: cvtAnswerContent(answer.answer),
            options: cvtAnswerOptions(answer.shortcut_bar),
            updateState: "",
            uId: uniqueId(),
            answerEditor: answer.answer_editor,
            answerEditorTime: answer.answer_edit_time,
        };
    });
}

// 意图单个答案数据转换
function intentCvtAnswerList(result) {
    const answers = [JSON.parse(result.answer_all_conf)] || [];
    return answers.map(function(answer) {
        return {
            name: answer.answer_alias,
            id: result.answer_id,
            props: cvtAnswerProp(JSON.stringify(answer.answer_attribute), JSON.stringify(answer.tag)),
            contents: cvtAnswerContent(JSON.stringify(answer.answer)),
            options: cvtAnswerOptions(JSON.stringify(answer.shortcut_bar)),
            updateState: "",
            uId: uniqueId()
        };
    });
}

// 相似问法列表
function cvtSimilarList(result) {
    const simliars = result.list;

    return simliars.map(function(simlilar) {
        return {
            updateState: "",
            extQuestion: simlilar.ext_question,
            extQuestionId: simlilar.ext_question_id,
            questionId: simlilar.question_id,
            sceneId: simlilar.set_id
        };
    });
}

function cvtAnswerProp(propJson, answerTags, dmStatus) {
    let propObj = propJson && JSON.parse(propJson);
    if (!propObj.value) {
        return {
            effectTime: {
                startTime: "",
                endTime: ""
            },
            effectChannel: {
                channel: effectChannel
            },
            effectUser: defaultPropId,
            answerStatus: answerStatus.ENABLE // 答案状态默认启用
        };
    }

    let ret = {};
    propObj.value.forEach(function(prop) {
        if (prop.type && prop.type == "validity") {
            ret.effectTime = {
                startTime: (prop.value && prop.value.start_time) || "",
                endTime: (prop.value && prop.value.end_time) || "",
                curRadio: prop.value && (prop.value.end_time || prop.value.start_time) ? "custom" : "all"
            };
        } else if (prop.type && prop.type == "vip_level") {
            ret.effectUser = (answerTags && JSON.parse(answerTags)) || defaultPropId;
        } else if (prop.type && prop.type == "channel") {
            ret.effectChannel = {
                channel: filterChannelData(prop.value) || effectChannel
            };
        } else if (prop.type && prop.type == "status") {
            ret.answerStatus = `${prop.value}`;
        }
    });

    if (dmStatus) {
        ret.dmStatus = JSON.parse(dmStatus);
    }

    // 以前答案没有status，赋默认启用
    if (!ret.answerStatus) {
        ret.answerStatus = answerStatus.ENABLE;
    }

    return ret;
}

// 特殊处理，只有在内容助手下需做过滤处理
function filterChannelData(channel) {
    let gameId = window.localStorage.getItem("gameId");
    if (gameId === "80002") {
        channel = channel.filter(item => {
            return item.indexOf("xy_") === -1;
        });
    }

    return channel;
}

// 各种类型组件服务端格式转客户端格式
function cvtAnswerContent(contentJson) {
    let contents = JSON.parse(contentJson);
    let ret = [];
    contents.forEach(function(content) {
        const widgetHandler = content.type != "container" ? widgetManager.serverMap[cvtClientType(content.type)] : cvtContainerAnswer(content);
        widgetHandler && ret.push(widgetHandler.server2Client.call(null, content));
    });

    return ret;
}

function cvtClientType(type) {
    let curType = type;
    switch (type) {
        case "image":
            curType = "picture";
            break;
        case "tip":
            curType = "singleTip";
            break;
        case "video":
            curType = "singleVideo";
            break;
        default:
            curType = type;
    }
    return curType;
}

// 服务端转客户端组件container格式需要特殊处理
function cvtContainerAnswer(content) {
    const contents = content.container_content;
    const itemNum = contents.length;

    if (!itemNum) {
        return;
    }

    const firstElem = contents[0].element;
    let serverMapName = "question";
    if (firstElem.type == "video") {
        serverMapName = "video";
    } else if (firstElem.type == "tip") {
        serverMapName = "tip";
    } else if (firstElem.type == "image") {
        serverMapName = "image";
    }

    return widgetManager.serverMap[serverMapName];
}

function cvtAnswerOptions(optionJson) {
    let options = JSON.parse(optionJson);
    let ret = [];
    options.map(function(option) {
        if (!option.question_id && option.form_id) {
            ret.push({
                uId: uniqueId(),
                name: option.name,
                questionId: "",
                formId: option.form_id || "",
                tagIds: option.tag_id,
                updateState: "add",
                itemType: "labor",
                optionType: "question"
            });
        } else {
            ret.push({
                uId: uniqueId(),
                name: option.name,
                questionId: option.question_id,
                question: option.question || "",
                updateState: "",
                optionType: "question"
            });
        }
    });

    return ret;
}

// 转换成后台需要的参数结构
function cvt2ServerParam(reqData) {
    const info = reqData.questionInfo;

    return {
        type: reqData.saveType,
        set_id: info.sceneClassId,
        question: info.standQuestion,
        question_id: String(info.questionId),
        fast_name: info.optionTip,
        lang: info.lang,
        en_question_id: info.enQuestionId,
        ext_question_array: JSON.stringify(cvt2ServerSimilar(reqData)),
        answer_array: JSON.stringify(cvt2ServerAnswer(reqData)),
        cluster_id: info.clusterId || "",
        cluster_lang: info.clusterLang || "",
        cluster_question_id: info.clusterQuestionId || "",
        smart_question_id: info.conventionQuestionId || "",
        is_like_display: info.isLikeDisplay,
        order_answer_ids: JSON.stringify(reqData.answers.map((item) => (item.id || item.uId))),
    };
}

// 意图单个答案转换成后台需要的参数结构
function cvtAnswer2ServerParam(reqData) {
    return {
        answer_id: reqData.dbData.answerId || "",
        database_id: reqData.dbData.dbId,
        intention_id: reqData.dbData.intentId,
        entity_id: reqData.dbData.entityId,
        status: reqData.saveType,
        answer: JSON.stringify(cvt2ServerAnswer(reqData)[0] || [])
    };
}

function cvt2ServerSimilar(reqData) {
    const questionId = reqData.questionInfo.questionId;

    // 编辑
    if (questionId) {
        return cvt2ServerSimlarObj(reqData.similar, reqData.deletedSimilars);
    }

    return reqData.similar.map(function(sml) {
        return sml.extQuestion;
    });
}

function cvt2ServerSimlarObj(similar, deletedSimilars) {
    let ret = [];

    similar.forEach(function(sml) {
        sml.updateState != "" &&
            ret.push({
                ext_question_id: sml.extQuestionId || "",
                text: sml.extQuestion,
                opt: sml.updateState
            });
    });

    deletedSimilars.forEach(function(sml) {
        ret.push({
            ext_question_id: sml.extQuestionId,
            text: sml.extQuestion,
            opt: sml.updateState
        });
    });

    return ret;
}

function cvt2ServerAnswer(reqData) {
    let ret = [];

    reqData.answers.forEach(function(answer) {
        answer.updateState != "" &&
            ret.push({
                answer_id: answer.id || "",
                answer_alias: answer.name,
                answer: cvt2ServerContent(answer.contents),
                shortcut_bar: cvt2ServerOption(answer.options),
                answer_attribute: cvt2ServerPorp(answer.props),
                dm_status: answer.props.dmStatus,
                tag: answer.props.effectUser,
                opt: answer.updateState,
                add_answer_id : answer.id || answer.uId,
            });
    });

    return ret;
}

// 各种类型组件客户端格式转服务端格式
function cvt2ServerContent(contents) {
    let ret = [];

    contents.forEach(function(content) {
        const widgetHandler = widgetManager.clientMap[content.wtType];
        content.updateState != "delete" && widgetHandler && ret.push(widgetHandler.client2Server.call(null, content));
    });

    return ret;
}

function cvt2ServerOption(options) {
    let ret = [];

    options.forEach(function(option) {
        if (option.itemType !== "labor" && option.updateState != "delete") {
            ret.push({
                type: "shortcut_bar",
                name: option.name,
                question_id: String(option.questionId)
            });
        }
        if (option.itemType === "labor") {
            ret.push({
                type: "shortcut_bar",
                name: option.name,
                question_id: "",
                tag_id: option.tagIds,
                form_id: option.formId
            });
        }
    });

    return ret;
}

function cvt2ServerPorp(props) {
    return {
        type: "property",
        value: [
            {
                type: "validity",
                value: {
                    start_time: props.effectTime.curRadio == "all" ? "" : props.effectTime.startTime,
                    end_time: props.effectTime.curRadio == "all" ? "" : props.effectTime.endTime
                }
            },
            {
                type: "vip_level",
                value: ""
            },
            {
                type: "status",
                value: props.answerStatus
            },
            {
                type: "channel",
                value: props.effectChannel.channel
            }
        ]
    };
}

// 答案基础属性转换
function cvtBaseProp(result) {
    let ret = {
        defaultId: [] // 默认选中的ID
    };
    result.attributes &&
        result.attributes.forEach(item => {
            if (item.group_name == "小悦活跃" || item.group_name == "vip") {
                ret.defaultId = ret.defaultId.concat(setDefaultId(item.value));
                ret.applChannel = cvtClientData(item.value);
            } else if (item.group_name == "时间") {
                ret.defaultId = ret.defaultId.concat(setDefaultId(item.value));
                ret.effectTime = cvtClientData(item.value);
            }
        });

    return ret;
}

// 基础属性设置默认选中ID转换
function setDefaultId(data) {
    let ret = [];
    data.forEach(item => {
        ret.push(item.id);
    });

    return ret;
}

// 用户画像属性转换
function cvtPortraitProp(result) {
    let ret = [];
    result.tags &&
        result.tags.forEach(item => {
            ret.push({
                name: item.group_name || item.classify_name, // 支持v1 v2两个组件的数据格式
                value: cvtClientData(item.value)
            });
        });

    return ret;
}

function cvtClientData(data) {
    let modalData = [];
    modalData = data.map(item => {
        return {
            label: item.name,
            value: item.id + ""
        };
    });

    return modalData;
}

export default {
    cvtQuesInfo,
    cvtAnswerList,
    intentCvtAnswerList,
    cvtSimilarList,
    cvt2ServerParam,
    cvtAnswer2ServerParam,
    cvtBaseProp,
    cvtPortraitProp
};
